import { Link } from '@backstage/core-components';
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@material-ui/core';

const styles = {
  card: {
    height: '98%',
  },
  cardActions: {
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '35.00%',
    backgroundPosition: '0 15%',
  },
  paragraph: {
    marginTop: '1rem',
  },
  link: {
    margin: '1em 0',
  },
};

const imageUrl = '/img/photo/stock-chatting-small.jpeg';

export const FeedbackCard = () => (
  <Card style={styles.card}>
    <CardMedia style={styles.cardMedia} image={imageUrl} />
    <CardContent>
      <Typography gutterBottom variant="h6" component="div">
        We'd love to hear from you
      </Typography>
      <Typography variant="body2">
        Your feedback is vital in driving the growth of this portal.
      </Typography>
      <Typography variant="body2" style={styles.paragraph}>
        Please share any feedback through one of the following.
      </Typography>
    </CardContent>
    {/* `any` is because of a TS types issue */}
    <CardActions style={styles.cardActions as any}>
      <Link to="https://forms.office.com/Pages/ResponsePage.aspx?id=jEfqO4QWjEqOhQRexUukMNmWxD4jb4dGkhSLw6iZJ5xUNUZEMkRWTUpLQ0JTM0NBUVhSNlZaM1NQMCQlQCN0PWcu">
        Fill out our feedback form
      </Link>
      <Link
        style={styles.link}
        to="https://go.oncehub.com/PrincipalDeveloperPortal"
      >
        Select a time to connect
      </Link>
    </CardActions>
  </Card>
);
